var app = angular.module('leonardo');

var WorkFlowInstanceDeleteFilters = function(
  $scope,
  $controller,
  WorkFlowInstanceService,
  UnitService,
  $rootScope,
  WorkFlowService
) {

  $controller('FiltersBaseController', { $scope: $scope });

  $scope.$on('filter-service:filter-changed', function ($event, key, value) {
    if (key === 'account_reports' || key === 'property_reports') {
      var changed_filters = angular.copy($scope.filters_options);
      angular.forEach(changed_filters, function(filter){
        if (filter.id === 'unit') {
          filter.serviceParams = { 
            account: $scope.filterService.getFilter('account_reports'),
            property: $scope.filterService.getFilter('property_reports')
          };
        }
        if (filter.id === 'workflow') {
          filter.serviceParams = { 
            account: $scope.filterService.getFilter('account_reports')
          };
        }
      });
      $scope.filters_options = changed_filters;
      
      // Re-initialize the workflow filter when account selection changes
      if (key === 'account_reports') {
        $rootScope.$broadcast('filter-service:workflow-update');
      }
    }
  });

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'managed_by_reports',
          name: 'Management Company',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Management Companies',
          condition: $scope.filterService.managers.length > 1,
          options: $scope.filterService.managers,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'account_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Portfolios',
          condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account,
          options: $scope.filterService.portfolios,
          conflicts: ['property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'property_reports',
          name: 'Property',
          label: null,
          inline: false,
          type: 'property_selector',
          multiple: true,
          placeholder: 'All Properties',
          condition: $scope.filterService.properties.length > 1 && !$scope.only_account,
          options: $scope.filterService.properties,
          conflicts: ['portfolio_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      id: 'workflow_status',
      name: 'Workflow Status',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Status',
      condition: true,
      options: WorkFlowInstanceService.STATUS_OPTIONS,
      conflicts: []
    },
    {
      id: 'search',
      name: 'Workflow Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Workflow name',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    },
    {
      id: 'started_from_date',
      name: 'Launched Date From',
      label: null,
      inline: false,
      type: 'date',
      placeholder: 'Launched Date From',
      conflicts: [],
      condition: true,
      positionVertical: 'bottom',
      endDate: 'started_to_date'
    },
    {
      id: 'started_to_date',
      name: 'Launched Date To',
      label: null,
      inline: false,
      type: 'date',
      placeholder: 'Launched Date To',
      conflicts: [],
      startDate: 'started_from_date',
      dateNoFuture: true,
      condition: true,
      positionVertical: 'bottom'
    },
    {
      id: 'date_range_started',
      name: 'Launched Date Range',
      label: null,
      inline: false,
      type: 'date_range',
      placeholder: 'Launched Date Range',
      conflicts: [],
      startDate: 'started_from_date',
      endDate: 'started_to_date',
      condition: true
    },
    {
      id: 'unit',
      name: 'Units',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Units',
      condition: true,
      service: UnitService,
      serviceParams: { 
        account: $scope.filterService.getFilter('account_reports'), 
        property: $scope.filterService.getFilter('property_reports') 
      },
      conflicts: []
    },
    {
      id: 'workflow',
      name: 'Workflow',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'Select workflow',
      condition: function() {
          return $scope.filterService.hasFilter('account_reports');
        },
      service: WorkFlowService,
      serviceParams: { account: $scope.filterService.getFilter('account_reports')},
      conflicts: [],
    },

  ];

};

app.controller('WorkFlowInstanceDeleteFilters', [
  '$scope',
  '$controller',
  'WorkFlowInstanceService',
  'UnitService',
  '$rootScope',
  'WorkFlowService',
  WorkFlowInstanceDeleteFilters
]);
